AppController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$localStorage',
    '$window',
    '$document',
    '$timeout',
    'cfpLoadingBar',
    '$uibModal',
    'CreateCashMovementModal',
    'disabled_features',
    'Club',
    'User',
    'Court',
    'Backoffice',
    'SessionSync',
    'Notifications',
    'NotificationFactory',
];

/* @ngInject */
function AppController(
    $rootScope,
    $scope,
    $state,
    $localStorage,
    $window,
    $document,
    $timeout,
    $cfpLoadingBar,
    $uibModal,
    CreateCashMovementModal,
    disabled_features,
    Club,
    User,
    Court,
    Backoffice,
    SessionSync,
    Notifications,
    NotificationFactory,
) {
    NotificationFactory.init();
    $rootScope.$on('user:login', Notifications.activate);
    $rootScope.$on('user:logout', Notifications.deactivate);

    //var vm = this;

    // Loading bar transition
    // -----------------------------------
    var $win = $($window);

    $scope.feedback = function () {
        $uibModal.open({
            template: require('../../views/feedback.html'),
            controller: 'FeedbackController',
            controllerAs: 'vm',
            windowClass: 'zindex',
            bindToController: true,
        });
    };

    $scope.registerCashMovement = function (type, booking_id = null) {
        CreateCashMovementModal.open(
            { type, booking_id, user: User.data.name },
            {
                onUpdated: () => {
                    $rootScope.$broadcast('cashMovementRegistered');
                },
            },
        );
    };

    $scope.hasFeature = function (feature) {
        return !disabled_features.includes(feature);
    };

    $scope.goToMyWeb = function () {
        const clubId = Club.id;
        const origin = window.location.origin;

        // Local
        if (origin.includes('127.0.0.1') || origin.includes('localhost')) {
            window.open(
                `https://beta.atcsports.io/sportclub/${clubId}`,
                '_blank',
            );
            return;
        }

        // URL basada en el origen actual
        const finalUrl = `${origin}/sportclub/${clubId}`;
        window.open(finalUrl, '_blank');
    };

    $scope.getClubInfo = function () {
        return {
            sportclub_id: Club.id,
            club_name: Club.name,
            user_name: User.data.name,
            user_id: User.data.id,
            is_admin: User.isAdmin(),
        };
    };

    $scope.onlyShowOnArgentina = function () {
        return Club.zone.country_id === 1;
    };

    $rootScope.cropper = function (params) {
        return $uibModal.open({
            template: require('../components/cropper/cropper.modal.html'),
            controller: 'CropperController',
            controllerAs: 'vm',
            bindToController: true,
            windowClass: 'zindex',
            resolve: {
                params: params,
            },
        });
    };

    $rootScope.$on('$stateChangeStart', function () {
        //start loading bar on stateChangeStart
        $cfpLoadingBar.start();
    });

    $rootScope.$on(
        '$stateChangeError',
        function (event, toState, toParams, fromState, fromParams, error) {
            //stop loading bar on stateChangeError
            $timeout($cfpLoadingBar.complete, 100);
        },
    );
    $rootScope.$on('$stateChangeSuccess', function (event) {
        //stop loading bar on stateChangeSuccess
        event.targetScope.$watch('$viewContentLoaded', function () {
            $cfpLoadingBar.complete();
        });

        // scroll top the page on change state
        $('#app .main-content').css({
            position: 'relative',
            top: 'auto',
        });
        $('footer').show();

        window.scrollTo(0, 0);

        // Save the route title
        $rootScope.currTitle = $state.current.title;
    });

    $rootScope.pageTitle = function () {
        return (
            (($rootScope.app.club && `${$rootScope.app.club.name} - `) || '') +
            $rootScope.app.name +
            ' - ' +
            ($rootScope.currTitle || $rootScope.app.description || '')
        );
    };

    // save settings to local storage
    if (angular.isDefined($localStorage.layout)) {
        $scope.app.layout = $localStorage.layout;
    } else {
        $localStorage.layout = $scope.app.layout;
    }

    // Save version
    if (
        angular.isDefined($localStorage.version) &&
        $scope.app.version !== $localStorage.version
    ) {
        console.log(
            'Updated verson. From: ' +
                $localStorage.version +
                ' to ' +
                $scope.app.version,
        );
    }
    $localStorage.version = $scope.app.version;

    $scope.$watch(
        'app.layout',
        function () {
            // save to local storage
            $localStorage.layout = $scope.app.layout;
        },
        true,
    );

    //global function to scroll page up
    $scope.toTheTop = function () {
        $document.scrollTopAnimated(0, 600);
    };

    // Function that find the exact height and width of the viewport in a cross-browser way
    var viewport = function () {
        var e = window,
            a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return {
            width: e[a + 'Width'],
            height: e[a + 'Height'],
        };
    };
    // function that adds information in a scope of the height and width of the page
    $scope.getWindowDimensions = function () {
        var vp = viewport();
        return {
            h: vp.height,
            w: vp.width,
        };
    };
    // Detect when window is resized and set some variables
    $scope.$watch(
        $scope.getWindowDimensions,
        function (newValue) {
            $scope.windowHeight = newValue.h;
            $scope.windowWidth = newValue.w;

            if (newValue.w >= 992) {
                $scope.isLargeDevice = true;
            } else {
                $scope.isLargeDevice = false;
            }
            if (newValue.w < 992) {
                $scope.isSmallDevice = true;
            } else {
                $scope.isSmallDevice = false;
            }
            if (newValue.w <= 768) {
                $scope.isMobileDevice = true;
            } else {
                $scope.isMobileDevice = false;
            }
        },
        true,
    );
    // Apply on resize
    $win.on('resize', function () {
        $scope.$apply();
        if ($scope.isLargeDevice) {
            $('#app .main-content').css({
                position: 'relative',
                top: 'auto',
                width: 'auto',
            });
            $('footer').show();
        }
    });

    $rootScope.$on('user:login', async () => {
        try {
            const courts = await Club.API.getList('courts', { full: true });
            const courts_ids = courts.map((c) =>
                Court.create(c, true).id.toString(),
            );
            const whitelist =
                await Backoffice.api.ifSomeCourtBelongWhiteListMatches({
                    courts: courts_ids,
                });

            if (whitelist.length) {
                $('#matches-menu').removeClass('hidden');
            }
        } catch (err) {
            console.error('Error al verificar whitelist de canchas:', err);
        }
    });

    // Init session sync service
    SessionSync.init();

    let tabId =
        window.crypto?.randomUUID?.() ||
        'tab-' + Math.random().toString(36).substring(2, 9);
    $rootScope.tabId = tabId;
    window.tabId = tabId;

    // Clean up the service when the scope is destroyed
    $scope.$on('$destroy', function () {
        SessionSync.destroy();
    });
}

export default AppController;
